import { useMutation } from "@tanstack/react-query";
import { confirmPhone } from "@/http/userApi";

export const useConfirmPhoneMutation = () => {
  return useMutation({
    mutationFn: async (phone: string) => {
      return await confirmPhone(phone);
    },
  });
};
